// extracted by mini-css-extract-plugin
export default {"wrapper":"input_wrapper__bBZ-Z","input":"input_input__8x+wP","label":"input_label__pl866","error":"input_error__QnCqG"};